import { render, staticRenderFns } from "./DelivSelector.vue?vue&type=template&id=28146cbd&lang=pug"
import script from "./DelivSelector.vue?vue&type=script&lang=js"
export * from "./DelivSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports